import moment from "moment"
import {capitalize, isEmpty} from "lodash"

export const getMaxDay = (year, month) => {
  if (!isEmpty(month)) {
    return moment(
      `${!isEmpty(year) ? year : moment().year()}-${month}`,
      "YYYY-MM").daysInMonth()
  }
  return 31
}

export const getDaysForSelect = (year, month) => {
  const maxDay = getMaxDay(year, month)
  const days = []
  for (let day = 1; day <= maxDay; day++) {
    const currentDay = day.toString().length > 1 ? day.toString() : `0${day}`
    days.push({label: currentDay, value: currentDay})
  }
  return [{label: "", value: null}, ...days]
}

export const getMonthsForSelect = (formatDate) => {
  const months = [{label: "", value: null}]
  const arr = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
  const year = new Date().getFullYear()
  arr.map((month, i) => {
    months.push({label: capitalize(formatDate(new Date(year, i), {month: "long"})), value: month})
  })
  return months
}

export const getYearsForSelect = (isMinimumAge18 = false) => {
  // hardcoded to 2017 as BE is also hardcoded, ideally would/ should be dynamic
  const DEFAULT_MAX_YEAR = 2017
  const maxYear = isMinimumAge18 ? new Date().getFullYear() - 18 : DEFAULT_MAX_YEAR
  const minYear = maxYear - 100
  let years = []
  for (let i = maxYear; i > minYear; i--) {
    years = [...years, i]
  }
  return [{label: "", value: null}, ...years.map((year) => ({label: year.toString(), value: year.toString()}))]
}

export const setDate = (value) => {
  if (!value) {
    return {
      day: "",
      month: "",
      year: ""
    }
  }
  const values = value.split("-")
  if (values.length === 3) {
    return {
      day: values[2],
      month: values[1],
      year: values[0]
    }
  }
  return {
    day: values[1],
    month: values[0],
    year: ""
  }
}
